// extracted by mini-css-extract-plugin
export default {"drawer":"CategoryDrawer_drawer__LsGg1","content":"CategoryDrawer_content__bA4NF","launchBtn":"CategoryDrawer_launchBtn__TfpFk"};